/* eslint-disable import/prefer-default-export */
/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */

export enum StorageBuckets {
  profilePhotos = '/profile_photos',
  secondaryProfilePhotos ='/profile_secondary_photos'
}
